export default "__VITE_ASSET__CVnnYspx__"